<template>
	<Column title="Flows" class="FlowSelectorColumn">
		<!--<ScrollView :style="{ maxHeight: '75vh' }">-->
		<ListView ref="flows" :items="items" :showIndex="true" @selected="select" class="FlowSelectorListView"/>
		<!--</ScrollView>-->
		<!--
		<div class="Center">
			<Button title="New Flow" @onPress="_createFlow" />
		</div>
		-->
	</Column>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import { Getter, Action, Mutation } from 'vuex-class';
	import Column from '../../Column';
	import ListView from '../../ListView';
	import Button from '../../Button';
	import ScrollView from '../../ScrollView';

	@Component({
		components: {
			Column,
			ListView,
			Button,
			ScrollView,
		},
	})
	export default class FlowSelector extends Vue {
		@Getter('api/homey/flow/structure') flowStructure;
		@Action('api/homey/flow/retrieveAll') retreiveFlows;
		@Mutation('api/homey/flow/select') selectFlow;
		index = 0;

		created() {
			if (!this.flowStructure) {
				this.retreiveFlows();
			}
		}

		select(flow) {
			this.selectFlow(flow);
		}

		get items() {
			if (!this.flowStructure) {
				this.retreiveFlows();
				return [{
					title: 'Loading Flows...'
				}];
			}
			return this.flowStructure.map(flowItem => ({
				...flowItem,
				class: { folder: flowItem.__athom_api_type === 'HomeyAPI.ManagerFlow.Folder' }
			}));
		}

		_createFlow() {
			console.log('_createFlow')
		}
	}
</script>

<style lang="scss">
	.FlowSelectorListView .folder {
		color: darkgrey;
	}
</style>